var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.$route.path.includes('us/')),expression:"!$route.path.includes('us/')"}],attrs:{"id":"cs-line"}},[_c('img',{attrs:{"src":require("../assets/imgs/line-icon.png"),"alt":"insto cs line"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }